export default __webpack_public_path__ + "static/media/35.e50e8e38.jpeg";